// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uDrEq","title_text":"styles_title_text__7EkLl","check":"styles_check__OCdV5","desc":"styles_desc__hL0EC"};